import type { ToastProps } from './Toast.types';

export type RemoveToastArgs = number;

let toasts: ToastProps[] = [];
let listeners: (() => void)[] = [];

export const toastStore = {
  remove(id?: string) {
    if (!id) {
      toasts = [];
    }

    toasts = toasts.filter((toast) => toast.id !== id);

    emitChange();
  },
  add(props: ToastProps) {
    toasts = [...toasts, { ...props, id: `${toasts.length}-${new Date().getTime()}` }];

    emitChange();
  },
  subscribe(listener: () => void) {
    listeners = [...listeners, listener];

    return () => {
      listeners = listeners.filter((l) => l !== listener);
    };
  },
  getSnapshot() {
    return toasts;
  },
};

function emitChange() {
  for (const listener of listeners) {
    listener();
  }
}

export const toast = (props?: ToastProps) => toastStore.add(props || {});
export const removeToast = (id?: string) => toastStore.remove(id);
